define('app/lib/translations',[], function() {
  var translations = {
    'fa-IR': {
      'translation': {
        'area_missing': 'لطفا محله خود را انتخاب کنید',
        'city_missing': 'لطفا شهر خود را وارد کنید',
        'choose_city': 'لطفا شهر خود را انتخاب کنید',
        'choose_category': 'لطفا یکی از دسته‌بندی‌ها را انتخاب کنید',
        'choose_shipping_address': 'لطفا یک آدرس برای تحویل انتخاب کنید یا یک آدرس جدید بسازید',
        'comment_missing': 'لطفا نظر خود را وارد کیند',
        'coupon_code_missing': 'لطفا کد تخفیف اضافه خود را وارد نمایید',
        'suburb_missing': 'لطفا منطقه خود را انتخاب کنید',
        'current_password_missing': 'لطفا رمز عبور فعلی خود را وارد کنید',
        'email_invalid': 'لطفا آدرس ایمیل صحیح وارد نمایید',
        'email_missing': 'لطفا آدرس ایمیل خود را وارد نمایید',
        'phone_invalid': 'لطفا شماره همراه خود را صحیح وارد نمایید',
        'phone_missing': 'لطفا شماره همراه خود را وارد نمایید',
        'fullname_missing': 'لطفا نام و نام‌خانوادگی خود را وارد نمایید',
        'first_name_missing': 'لطفا نام خود را وارد نمایید',
        'full_name_missing': 'لطفا نام و نام‌خانوادگی خود را وارد نمایید',
        'gender_missing': 'لطفا جنسیت را وارد نمایید',
        'gift_from_missing': 'لطفا نام فرستنده هدیه را وارد نمایید',
        'gift_from_too_long': 'نام فرستنده طولانی است',
        'gift_message_missing': 'لطفا پیام هدیه را وارد نمایید',
        'gift_message_too_long': 'پیام هدیه طولانی است',
        'gift_to_missing': 'لطفا نام گیرنده هدیه را وارد نمایید',
        'gift_to_too_long': 'نام گیرنده هدیه طولانی است',
        'invalid_shipping_address': 'لطفا آدرس تحویل را دوباره انتخاب کنید',
        'items_remaining': '__n__ موارد باقیمانده',
        'items_sold': '__n__ موفق',
        'last_name_missing': 'لطفا نام خانوادگی خود را وارد نمایید',
        'name_missing': 'لطفا نام خود را وارد نمایید',
        'password_different': 'رمزهای عبور وارد شده یکسان نیستند',
        'password_invalid': 'لطفا رمز عبوری بین ۶ تا ۵۰ کاراکتر وارد نمایید',
        'payment_method_free': 'ﻮﻫﻭﻭﻭ. ﻩﺯیﻦﻫ ﺍی پﺭﺩﺎﺨﺗ ﻦﺧﻭﺎﻫیﺩ کﺭﺩ',
        'please_choose': 'انتخاب کنید',
        'postcode_missing': 'لطفا کدپستی خود را وارد نمایید',
        'telephone_missing': 'لطفا شماره تماس خود را وارد نمایید',
        'telephone_range': 'شماره تماس باید ۱۱ رقم باشد',
        'telephone_invalid': 'لطفا شماره تماس خود را صحیح وارد نمایید',
        'street_missing': 'لطفا نام خیابان را وارد نمایید',
        'region_missing': 'لطفا استان خود انتخاب کنید',
        'register_success': 'ثبت نام با موفقیت انجام شد. تا پنج ثانیه دیگر به صفحه قبل منتقل می شوید',
        'cart_empty': 'سبد خرید شما خالیست',
        'connection_error': 'ارتباط با سرور برقرار نشد . لطفا مجددا سعی کنید.',
        'connection_error_notify': 'در برقراری ارتباط با سرور مشکلی پیش آمد.',
        'connection_error_saving': 'در برقراری ارتباط با سرور جهت ذخیره اطلاعات مشکلی پیش آمد.',
        'landing_invitation_success': 'ثبت دعوت ها با موفقیت انجام شد. اکنون به صفحه اصلی منتقل می شوید.',
        'company_missing': 'لطفا نام کسب و کار خود را وارد کنید.',
        'password_missing': 'لطفا رمز عبور را وارد کنید.',
        'password_confirm_missing': 'لطفا تایید رمز عبور را وارد کنید.',
        'personnel_missing': 'لطفا تعداد ‍‍پرسنل را وارد کنید',
        'personnel_invalid': 'لطفا تعداد ‍‍پرسنل را به عدد وارد کنید',
        'privacy_policy_missing': 'برای ثبت نام باید شرایط عضویت را بپذیرید',
        'invite_code_missing':'لطفا کد دعوت را وارد کنید',
        'organizational_identifier_missing':'لطفا شناسه سازمانی را وارد کنید',
        'required': 'این مورد اجباری است',
        'login': 'ورود',
        'shipping': 'اطلاعات تحویل گیرنده',
        'address': 'افزودن آدرس جدید',
        'success_bank': 'پرداخت کارت به کارت',
        'success_online': 'پرداخت انلاین',
        'payment': 'نحوه پرداخت',
        'buy_with_cell_phone': 'خرید فقط با اپلیکیشن موبایل',
        'deal_sold_out': 'این تخفیفان به پایان رسید',
        'refreshing_payment_method': 'تا لحظاتی دیگر روش های پرداخت بروز رسانی میشوند...',
        'payment_methods_refreshed': 'روش های پرداخت بروز رسانی شد، لطفا مجددا تلاش کنید.',
        'checkout_session_expire' : 'متاسفانه جلسه کاربری شما منقضی شده است، می بایست فرآیند خرید را از ابتدا آغاز کنید و اگر عضو سایت هستید وارد شوید',
        'an_error_occurred': 'خطایی رخ داد، لطفا مجددا تلاش کنید.',
        'successfully_logged_in_yadisa': 'با موفقیت وارد یادیسا شدید',
        'successfully_logged_in_takhfifan': 'با موفقیت وارد تخفیفان شدید',
        'question_missing': 'لطفا دیدگاه خود رابنویسید',
        'please_enter_valid_email': 'لطفا ایمیل خود را وارد کنید.',
        'please_enter_your_name': 'لطفا نام خود را وارد کنید',
        'price_changed_new_price': 'توجه کنید که قیمت تغییر کرد. قیمت جدید :',
        'continue_shopping': 'آیا مایل به ادامه خرید هستید ؟',
        'coupon_code_read_error': 'متاسفانه دریافت اطلاعات کوپن به درستی انجام نشد',
        'train_sending_success': 'کاربر گرامی اطلاعات شما ثبت شد. طبق قوانین راه‌آهن جمهوری اسلامی ایران، کد بلیط ۴۸ ساعت مانده به حرکت قطار از طریق پیامک برای شما ارسال می‌شود. با استفاده از این کد می‌توانید بلیط خود را در باجه «خرید اینترنتی» واقع در راه آهن چاپ کنید. در صورتی که تا دو روز مانده به سفر کدی را دریافت نکردید با پشتیبانی تخفیفان تماس بگیرید.',
        'buy_forbidden': 'شما مجاز به خرید این محصول نمی باشید',
        'tag_page_count_read_error': 'متاسفانه دریافت اطلاعات محصولات به درستی انجام نشد',
        'coupon_code_free_received_before': 'کاربر عزیز شما قبلا برای این تخفیف کد دریافت کرده اید',
        'contact_missing': 'لطفا ایمیل یا شماره تلفن خود را وارد نمایید',
        'contact_invalid': 'لطفا ایمیل یا شماره تلفن خود را بدرستی نمایید',
        'invalid_bank_card': 'شماره کارت بانکی وارد شده صحیح نمی باشد',
        'bank_card_added_successfully': 'کارت بانکی شما با موفقیت اضافه گردید',
        'success_bank_card_added_gift_failed': 'متاسفانه در فرآیند هدیه شما ایرادی رخ داده لطفا با پشتیبانی تماس بگیرید'
      }
    },
    'en': {
      'translation': {
        'area_missing': 'Please choose your suburb',
        'city_missing': 'Please enter your city',
        'choose_city': 'Please choose your city',
        'choose_shipping_address': 'Please choose a delivery address or enter a new one',
        'comment_missing': 'Please enter a comment',
        'coupon_code_missing': 'Please enter the discount code',
        'suburb_missing': 'Please choose your city district',
        'current_password_missing': 'Please enter your current password',
        'email_invalid': 'Please correct your email address',
        'email_missing': 'Please enter your email',
        'first_name_missing': 'Please enter your first name',
        'gender_missing': 'Please enter your gender',
        'gift_from_missing': 'Please enter your name as the gift sender',
        'gift_from_too_long': 'Your name as gift sender is too long',
        'gift_message_missing': 'Please enter a gift message',
        'gift_message_too_long': 'Your gift message is too long',
        'gift_to_missing': 'Please enter the name of the gift recipient',
        'gift_to_too_long': 'The name of the gift recipient is too long',
        'invalid_shipping_address': 'Please try to choose a delivery address again',
        'items_remaining': '__n__ موارد باقیمانده',
        'items_sold': '__n__ موفق',
        'last_name_missing': 'Please enter your last name',
        'name_missing': 'Please enter your name',
        'password_different': 'The passwords you entered do not match',
        'password_invalid': 'Please enter a password with 6-50 characters',
        'payment_method_free': 'وهووو. هزینه ای پرداخت نخواهید کرد',
        'please_choose': 'Please choose',
        'postcode_missing': 'Please enter your zip code',
        'telephone_missing': 'Please enter your phone number',
        'telephone_range': 'The phone number must be 11 digits',
        'telephone_invalid': 'Please correct your phone number',
        'street_missing': 'Please enter your street',
        'region_missing': 'Please choose your state',
        'register_success': 'Thank your for registering. You will be redirected to the previous page shortly.',
        'cart_empty': 'Your cart is empty.',
        'connection_error': 'An error happened while connecting to server.Please try again.',
        'connection_error_notify': 'An error happened while connecting to server',
        'connection_error_saving': 'An error happened while saving data to server',
        'landing_invitation_success': 'Invitations registered successfully. You will be redirected to home page now.',
        'company_missing': 'Please enter your company name.',
        'password_missing': 'Please enter the password.',
        'password_confirm_missing': 'Please enter the password confirmation.',
        'personnel_missing': 'Please enter the number of personnel',
        'personnel_invalid': 'Please enter a number of personnel count',
        'privacy_policy_missing': 'for registerations you must accept termss & conditions',
        'invite_code_missing': 'Please enter the invite code',
        'organizational_identifier_missing': 'Please enter the organizational identifier',
        'required': 'This field is required',
        'login': 'login',
        'shipping': 'shipping',
        'success_bank': 'success with bank transfer',
        'success_online': 'success with online payment',
        'payment': 'payment',
        'buy_with_cell_phone': 'Buy with mobile app only',
        'deal_sold_out': 'Deal sold out',
        'refreshing_payment_method': 'payment methods will be refresh...',
        'payment_methods_refreshed': 'payment methods refreshed, try again.',
        'checkout_session_expire': 'your session is expired, you should start the checkout process from beginning',
        'an_error_occurred': 'An error occurred, please try again.',
        'successfully_logged_in_yadisa': 'successfully logged in yadisa',
        'successfully_logged_in_takhfifan': 'successfully logged in takhfifan',
        'please enter you comment': 'please enter you email address',
        'please_enter_your_name': 'please enter your name',
        'price_changed_new_price': 'Notice: The price has been changed. New price is : ',
        'continue_shopping': 'Do you want to continue shopping?',
        'coupon_code_read_error': 'Unfortunately, could not receive Coupon\'s information correctly',
        'train_sending_success': 'Your information is registered successfully. According to Islamic republic of Iran Railway rules, you ticked code will be sent you throw sms, 48 hours before ticket time. if you didn\'t receive the code in 2 days before the ticket time. please call to Takhfifan support team.',
        'buy_forbidden': 'You can not buy this product',
        'tag_page_count_read_error': 'Unfortunately, could not receive products\'s information correctly',
        'coupon_code_free_received_before': 'You received code before',
        'invalid_bank_card': 'Invalid Bank Card Number',
        'success_bank_card_added_gift_failed': 'Your bank card is added successfully but in gift process an error occurred, please call support'
      }
    }
  };
  return translations;
});

